import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@/components/Button";
import { reset, trackEvent } from "@/analytics";
import { NAVIGATION_EVENTS } from "@/analytics/events";

export const LogoutButton = () => {
  const { logout } = useAuth0();

  return (
    <Button
      buttonText="Logout"
      onClick={() => {
        // Track logout initiated
        trackEvent(NAVIGATION_EVENTS.LOGOUT_INITIATED, {
          source: "web",
        });

        reset();

        // Track logout completed just before redirect
        trackEvent(NAVIGATION_EVENTS.LOGOUT_COMPLETED, {
          source: "web",
        });

        logout({ returnTo: window.location.origin });
      }}
    />
  );
};

export const Logout = () => {
  return (
    //   page container
    <div className="flex-1  flex flex-col overflow-hidden">
      <div className="min-h-screen bg-background">
        <div className="py-10">
          <main>
            <div className="max-w-full mx-auto sm:px-6 lg:px-8">
              {/* Replace with your content */}

              <LogoutButton />
              {/* /End replace */}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};
